import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import ChiTietChoVaySub from "../ChiTietChoVaySub";
import DatePicker from "react-datepicker";
import LanThanhToanView from "../LanThanhToanView";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import thayDoiLaiSuatApi from "service/thayDoiLaiSuatApi";
import CauHinhApi from "../../../service/cauHinhApi";
import ThayDoiKyLaiApi from "../../../service/ChoVay/ThayDoiKyLaiApi";

import choVayConst, {
  bindKieuLaiSuat,
  bindListKieuLaiSuat,
  bindTypePaid,
} from "../../../constants/choVayConst";
import { currentDateV2 } from "utils/formatDate";

class ThayDoiKyLai extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 6,
      },
      objData: {
        choVayId: 0,
        TenKhachHang: "",
        StartPaidTime: currentDate(),
        CountTypePaid: 0,
        TypePaid: 0,
        LaiSuat: 0,
        KieuLaiSuat: 0,
        SoLanTra: 0,
        NgayTraLai: currentDate(),
      },
      dataVayThemSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      actionDelete: false,
      idDelete: 0,
      lichSu: [],
      objConfigSysLoaiTS: {},
      objConfig: {},
    };
  }

  componentDidMount() {
    let { data, show } = this.props;
    let { choVay, objData } = this.state;
    // debugger;
    if (data && data.ChoVayId && show) {
      let { dataSearch, dataVayThemSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      dataVayThemSearch.choVayId = data.ChoVayId;
      objData.choVayId = data.ChoVayId;
      objData.LaiSuat = data.Phantram;
      objData.KieuLaiSuat = data.KieuLaiSuat;
      objData.TypePaid = data.TypePaid;
      objData.CountTypePaid = data.CountTypePaid;
      objData.StartPaidTime = currentDate();
      //DuyNN Thiếu cấu hình hiển thị ngày trả, đang fix trước số lần trả: chỗ ngày trả , số lần trả cần điều kiện để gán

      CauHinhApi.getTimeServer().then((response) => {
        if (response.status === 200) {
          let dateTime = new Date(convertDate(response.data.result));
          objData.StartPaidTime = currentDateV2(dateTime);
        }
      });

      objData.SoLanTra = 0;
      objData.NgayTra = null;
      this.setState({
        choVay: data,
        dataSearch,
        objData,
        dataVayThemSearch,
      });
      this.loadLanDongLai(dataSearch);
      this.loadLichsuChoVayInterests(data.ChoVayId);
      this.loadCauHinhLoaiTaiSan();
      this.loadCauHinhHeThong();
      if (data === choVay && !show) this.setState({ choVay: {} });
    }
  }

  loadLichsuChoVayInterests(choVayId) {
    if (choVayId != null && choVayId != undefined) {
      ThayDoiKyLaiApi.lichsuChoVayInterests({
        chovayID: choVayId,
        type: 4,
      }).then((response) => {
        if (response.status === 200) {
          this.setState({ lichSu: response.data }); // gán vào state
        }
      });
    }
  }
  loadCauHinhLoaiTaiSan() {
    CauHinhApi.getConfigSys_LoaiTaiSan1(null).then((response) => {
      let { objConfigSysLoaiTS } = this.state;
      this.setState({ objConfigSysLoaiTS: response.data });
    });
  }
  loadCauHinhHeThong() {
    CauHinhApi.getConfig(null).then((response) => {
      let { objConfig } = this.state;
      this.setState({ objConfig: response.data[0] });
    });
  }
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }

  handlePageChange = () => (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };

  thayDoiKyLai = () => () => {
    let { objData } = this.state;
    objData.ChoVayId = objData.choVayId;
    objData.PhanTram = objData.LaiSuat;
    objData.Type = 4;
    ThayDoiKyLaiApi.saveThayDoiKyLai(objData).then((response) => {
      if (response.status === 200) {
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response.data, "warning", "TOP_CENTER", 2000);
        return;
      }
    });
  };
  xoaThayDoiKyLai = (item) => {
    ThayDoiKyLaiApi.xoaThayDoiKyLai({ thaydoiID: item.InterestId }).then(
      (response) => {
        if (response.status === 200) {
          pushNotification(
            "Thao tác thành công",
            "success",
            "TOP_CENTER",
            2000,
          );
          let { objData } = this.state;
          this.loadLichsuChoVayInterests(objData.choVayId);
        } else {
          pushNotification(response.data, "warning", "TOP_CENTER", 2000);
          return;
        }
      },
    );
  };
  renderTableRow(lichSu) {
    return lichSu.map((item, index) => {
      return (
        <div class="custom-table-row">
          <div class="custom-table-cell flex-basis-6 flex-disk">
            <span class="mobile-column-name">STT</span>
            <div class="center-wrapper">
              <p class="text-center">{index + 1}</p>
            </div>
          </div>

          <div class="custom-table-cell flex-basis-10">
            <span class="mobile-column-name disk-mobile">Ngày đổi</span>
            <div class="center-wrapper">
              <p class="icon-dropdown-mobile text-center">
                <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                {getDate(item.StartPaidTime)}
              </p>
            </div>
          </div>

          <div class="custom-table-cell flex-basis-15 flex-disk">
            <span class="mobile-column-name  disk-mobile"> Kỳ đóng lãi</span>
            <div class="center-wrapper">
              <p class="text-right">{item.sKyDongLai}</p>
            </div>
          </div>
          <div class="custom-table-cell flex-basis-15 flex-disk">
            <span class="mobile-column-name  disk-mobile"> Lãi suất</span>
            <div class="center-wrapper">
              <p class="text-right">{item.sLaiSuat}</p>
            </div>
          </div>

          <div class="custom-table-cell flex-basis-15">
            <span class="mobile-column-name"> Số lần trả</span>
            <div class="center-wrapper">
              <p class="text-right">{item.SoLanTra}</p>
            </div>
          </div>
          <div class="custom-table-cell flex-basis-15 ">
            <span class="mobile-column-name"> Ngày trả</span>
            <div class="center-wrapper">
              <p class="text-center"> {getDate(item.NgayTra)}</p>
            </div>
          </div>
          <div class="custom-table-cell flex-basis-24 flex-disk">
            <span class="mobile-column-name">Ghi chú</span>
            <div class="center-wrapper">
              <p class="text-left">{item.Note}</p>
            </div>
          </div>

          <div class="custom-table-cell flex-basis-10 sticky-icon ">
            <div class="center-wrapper">
              <div class="inputTableMorman">
                {item.isXoa && (
                  <a
                    href={() => false}
                    onClick={() => this.xoaThayDoiKyLai(item)}
                  >
                    <i className="mdi mdi-delete"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  onChangeDate = (field) => (evt) => {
    let { objData } = this.state;
    objData[field] = formatDayMonth(evt);
    this.setState({ objData });
  };
  onChangeData = (field) => (event) => {
    let { objData } = this.state;
    objData[field] = event.target.value;
    if (field == "TypePaid") {
      let { objConfigSysLoaiTS } = this.state;
      var lstKieuLai = bindListKieuLaiSuat(
        objConfigSysLoaiTS,
        objData.TypePaid,
      );
      if (lstKieuLai.length > 0) {
        objData.KieuLaiSuat = lstKieuLai[0].value;
      }
    }
    this.setState(objData);
  };
  onChangeNumber = (field) => (evt) => {
    let { objData } = this.state;
    objData[field] = convertToNumber(evt.target.value);
    this.setState(objData);
  };
  render() {
    let props = this.props;
    let { data, quanlychovay, buttonLeft, chonngaygiaodich } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
      TongTienGocConLai,
    } = quanlychovay.objListDonglai;
    let { postThayDoiLaiSuatChoVayLoading } = quanlychovay;
    let { dataSearch, objData, objConfigSysLoaiTS, objConfig } = this.state;
    let { StartPaidTime, GhiChu, NgayTra } = objData;
    if (StartPaidTime) StartPaidTime = convertDate(StartPaidTime);
    if (NgayTra) NgayTra = convertDate(NgayTra);
    let { Type, StatusPaidHo } = data;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/logo-vay-them-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Thay đổi kỳ lãi
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="modal-thanh-toan-new">
          <div
            className={
              "loader loader-default " +
              (postThayDoiLaiSuatChoVayLoading ? "is-active" : "")
            }
          ></div>
          {this.state.HasTatToanChoDuyet === 1 && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="thongbaotattoan">
                    <i class="mdi mdi-alert" style={{ color: "#d39c00" }}></i>{" "}
                    HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row">
            <div className="col-md-12 col-lg-3 col-md-3-customers pad-right0">
              <div className="form-donglai-mobileshow">
                <h4>
                  <span
                    style={{
                      fontWeight: "bold !important;",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    {"   "}
                    <img src="/app-assets/images/icon-vay-them-trang.png" />
                    &nbsp;&nbsp; Nội dung thay đổi
                  </span>
                </h4>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-noidungtra"
                    aria-labelledby="base-tab1"
                  >
                    <div className="detail-tattoan">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ngày thực hiện</label>
                            <DateTimePicker
                              value={StartPaidTime}
                              onChange={this.onChangeDate("StartPaidTime")}
                              readOnly={!chonngaygiaodich}
                            ></DateTimePicker>
                          </div>
                        </div>

                        {(data.Type === 1 || data.Type === 3) && (
                          <>
                            <div
                              className="col-md-12"
                              style={{ paddingRight: "0px" }}
                            >
                              <div className="">
                                <label>Kỳ đóng lãi</label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="row">
                                <div
                                  className="col-md-6"
                                  style={{ paddingRight: "0px" }}
                                >
                                  <input
                                    type="text"
                                    className="form-control left input-sm"
                                    value={objData.CountTypePaid}
                                    onChange={this.onChangeData(
                                      "CountTypePaid",
                                    )}
                                  />
                                </div>
                                <div
                                  className="col-md-6"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <select
                                    className="form-control right  input-sm select-v2"
                                    onChange={this.onChangeData("TypePaid")}
                                    value={objData.TypePaid}
                                  >
                                    {bindTypePaid(objConfigSysLoaiTS)}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {(data.Type === 1 || data.Type === 3) && (
                          <>
                            <div
                              className="col-md-12"
                              style={{ paddingRight: "0px" }}
                            >
                              <div className="">
                                <label>Lãi xuất</label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="row">
                                <div
                                  className="col-md-6"
                                  style={{ paddingRight: "0px" }}
                                >
                                  <input
                                    type="text"
                                    className="form-control left input-sm"
                                    value={objData.LaiSuat}
                                    onChange={this.onChangeData("LaiSuat")}
                                  />
                                </div>
                                <div
                                  className="col-md-6"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <select
                                    className="form-control right  input-sm select-v2"
                                    onChange={this.onChangeData("KieuLaiSuat")}
                                    value={objData.KieuLaiSuat}
                                  >
                                    {bindKieuLaiSuat(
                                      objConfigSysLoaiTS,
                                      objData.TypePaid,
                                    )}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {objConfig.OptionTinhLai == 3 &&
                          (data.Type === 1 || data.Type === 3) && (
                            <>
                              <div
                                className="col-md-12"
                                style={{ paddingRight: "0px" }}
                              >
                                <div className="">
                                  <label>Số lần trả</label>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  value={objData.SoLanTra}
                                  onChange={this.onChangeData("SoLanTra")}
                                />
                              </div>
                            </>
                          )}
                        {objConfig.OptionTinhLai == 2 && (
                          <>
                            <div
                              className="col-md-12"
                              style={{ paddingRight: "0px" }}
                            >
                              <div className="form-group">
                                <label>Ngày trả gốc</label>
                                <DateTimePicker
                                  value={NgayTra}
                                  onChange={this.onChangeDate("NgayTra")}
                                ></DateTimePicker>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ghi chú</label>
                            <textarea
                              rows="3"
                              className="form-control input-sm textarea-fixed-height"
                              placeholder="Ghi chú"
                              value={GhiChu}
                              onChange={this.onChangeData("GhiChu")}
                            ></textarea>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet != 1 && (
                              <button
                                type="button"
                                className="btn btn-new-main btn-checknew"
                                onClick={this.thayDoiKyLai()}
                              >
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-check-underline-circle"></i>
                                </span>{" "}
                                Xác nhận
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-9 col-md-9-customers">
              <div className="tattoan-formright">
                <ul className="nav nav-tabs bg-tab">
                  <li className="nav-item active">
                    <a
                      className="nav-link active"
                      id="base-tab12"
                      data-toggle="tab"
                      aria-controls="tab12"
                      href="#tbg-thongtinhd"
                      aria-expanded="true"
                    >
                      <h4>Thông tin hợp đồng</h4>
                    </a>
                  </li>

                  <li className="nav-item active">
                    <a
                      className="nav-link"
                      id="base-tab13"
                      data-toggle="tab"
                      aria-controls="tab13"
                      href="#detailtbg"
                      aria-expanded="true"
                    >
                      <h4>Chi tiết đóng lãi</h4>
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tbg-thongtinhd"
                    aria-labelledby="base-tab1"
                  >
                    <div className="list-thongtinhopdong">
                      <div className="row">
                        <div className="col-md-12 col-sm-12">
                          <ChiTietChoVaySub
                            data={data}
                            TongTienGoc={
                              TongTienGocConLai
                                ? TongTienGocConLai
                                : TongTienGoc
                            }
                          ></ChiTietChoVaySub>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="detailtbg"
                    aria-labelledby="base-tab1"
                  >
                    <LanThanhToanView
                      List={List}
                      TongCanThanhToan={TongCanThanhToan}
                      TongPhiKhac={TongPhiKhac}
                      TongPhiKho={TongPhiKho}
                      TongThanhToan={TongThanhToan}
                      TongTienGoc={TongTienGoc}
                      TongTienLai={TongTienLai}
                      totalRow={totalRow}
                      TongPhiKhacHangKy={TongPhiKhacHangKy}
                      handlePageChange={this.handlePageChange()}
                      pageIndex={dataSearch.pageIndex}
                      pageSize={dataSearch.pageSize}
                      Type={Type}
                      StatusPaidHo={StatusPaidHo}
                    ></LanThanhToanView>
                  </div>
                </div>
              </div>
            </div>
            <div className="list-history" style={{ marginTop: "10px" }}>
              <h4 className="modal-title color7-bold" id="myModalLabel16">
                <span>Lịch sử Lãi suất</span>
              </h4>
              <div class="Left808x200 Table-main-new table-mobile-new">
                <div class="table-responsive table-responsive-new table-new1 table-rounded ">
                  <div class="custom-table-wrapper">
                    <div class="table-headers">
                      <div class="custom-table-header flex-basis-6">
                        <p class="text-center">
                          STT
                          <br />{" "}
                          <span class="red">
                            [ {this.state.lichSu.length} ]
                          </span>
                        </p>
                      </div>

                      <div class="custom-table-header flex-basis-10 ">
                        <p class="text-center">Ngày</p>
                      </div>

                      <div class="custom-table-header flex-basis-15">
                        <p class="text-right">Kỳ đóng lãi</p>
                      </div>
                      <div class="custom-table-header flex-basis-15">
                        <p class="text-right">Lãi suất</p>
                      </div>
                      <div class="custom-table-header flex-basis-15">
                        <p class="text-right">Số lần trả</p>
                      </div>
                      <div class="custom-table-header flex-basis-15">
                        <p class="text-center">Ngày trả</p>
                      </div>
                      <div class="custom-table-header flex-basis-24 ">
                        <p class="text-left">Ghi chú</p>
                      </div>
                      <div class="custom-table-header flex-basis-10">
                        <p class="tab-header text-center">Thao tác</p>
                      </div>
                    </div>

                    <div class="custom-table-body">
                      {this.renderTableRow(this.state.lichSu)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  className="btn btn-new-main btn-checknew"
                  onClick={props.onHide}
                >
                  &nbsp;
                  <i class="mdi mdi-close"></i>
                  &nbsp; Đóng&nbsp;
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThayDoiKyLai;
